/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import HeroPortfolio from 'parts/HeroPortfolio';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import AllPortfolio from 'parts/AllPortfolio';
import Seo from 'parts/Seo';

import { Portfolios } from 'json/landingPageData';

export default class ProjectPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Seo
          title="Layanan Teknisi CNC - Penjualan, Training, Service & Sparepart Mesin CNC"
          description="Temukan solusi lengkap kebutuhan CNC Anda: penjualan mesin baru, pelatihan operator & teknisi, jasa servis profesional, dan suku cadang berkualitas. Teknisi CNC berpengalaman siap melayani."
          keywords="layanan teknisi cnc, jual mesin cnc, training cnc, servis cnc, sparepart cnc, teknisi cnc indonesia, maintenance cnc, retrofit cnc, kursus cnc, pelatihan operator cnc"
          canonicalUrl="https://teknisi.space/project"
        />
        <Header />
        <HeroPortfolio />
        <AllPortfolio data={Portfolios} />
        <Discuss />
        <Footer />
      </>
    );
  }
}
